/**
 * 简单的响应时间测量原子
 */
import { atom } from 'jotai';

// 发送开始时间原子
export const sendStartTimeAtom = atom<number | null>(null);

// 是否已收到首个token原子
export const firstTokenReceivedAtom = atom<boolean>(false);

// 开始计时的原子
export const startResponseTimerAtom = atom(
  null,
  (get, set) => {
    const startTime = performance.now();
    set(sendStartTimeAtom, startTime);
    set(firstTokenReceivedAtom, false);
    console.log('[ResponseTime] 用户发送消息，开始计时');
  }
);

// 记录首个token响应时间的原子
export const recordFirstTokenAtom = atom(
  null,
  (get, set) => {
    const startTime = get(sendStartTimeAtom);
    const alreadyReceived = get(firstTokenReceivedAtom);

    if (startTime && !alreadyReceived) {
      const responseTime = performance.now() - startTime;
      console.log(`🎉 [ResponseTime] 首个token响应时间: ${responseTime.toFixed(2)}ms`);
      set(firstTokenReceivedAtom, true);
    }
  }
);
